/**
 * View component for /admin/authoring/content-modules/new
 *
 * Creates a new contentModule from a copy of the defaultItem in the contentModule reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as certificateTemplateActions from '../../certificateTemplate/certificateTemplateActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as contentModuleActions from '../contentModuleActions';

// import global components
import AlertModal from "../../../global/components/modals/AlertModal.js.jsx";
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import contentModule components
import ContentModuleForm from '../components/ContentModuleForm.js.jsx';

class AdminCreateContentModule extends Base {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: ''
      , formHelpers: {
        doesCertExpire: 'yes'
        , isNewConclusionContent: true
        , isNewOverviewContent: true
        , isTestable: 'no'
        , requiresAttestation: 'no'
        , showSentimentModal: true
      }
      , isAlertModalOpen: false
      , contentModule: _.cloneDeep(this.props.defaultContentModule)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_toggleAlertModal'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(sponsorActions.fetchListIfNeeded('all'));
    dispatch(certificateTemplateActions.fetchListIfNeeded('all'))
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    if(e.target.name === "contentModule.postEvalContent") {
      newState.formHelpers.isNewPostEvalContent = false;
    }
    if(e.target.name === "contentModule.allowAnonymous") {
      newState.formHelpers.isTestable = 'no';
      newState.formHelpers.requiresAttestation = 'no';
    }
    if(e.target.name === "contentModule.allowSimFeedback") {
      newState.contentModule.published = !e.target.value;
    }
    // NOTE: only do this on the create form
    if(e.target.name === "contentModule.title") {
      newState.contentModule.slug = _.kebabCase(e.target.value);
    }
    this.setState(newState);
    const { dispatch } = this.props;
    if(e.target.name === "contentModule._organization") {
      dispatch(studyActions.fetchListIfNeeded("_organization", e.target.value));
    }
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch, history } = this.props;
    const { formHelpers } = this.state;
    let newContentModule = _.cloneDeep(this.state.contentModule);
    newContentModule.testable = (formHelpers.isTestable === 'yes');
    newContentModule.requiresAttestation = (formHelpers.requiresAttestation === 'yes');
    newContentModule.showSentimentModal = formHelpers.showSentimentModal; 

    if(formHelpers.doesCertExpire === 'no') {
      newContentModule.certificateDuration = null;
    }
    dispatch(contentModuleActions.sendCreateContentModule(newContentModule)).then((action) => {
      if(action.success) {
        dispatch(contentModuleActions.invalidateList());
        history.push(`/admin/authoring/content-modules/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        // alert("ERROR: "+action.error);
        this._toggleAlertModal(action.error);
      }
    });
  }

  _toggleAlertModal(message) {
    this.setState({
      alertMessage: message || ''
      , isAlertModalOpen: !this.state.isAlertModalOpen
    });
  }

  render() {
    const { 
      certificateTemplateStore
      , location
      , sponsorStore
      , studyStore 
    } = this.props;
    const { formHelpers, contentModule } = this.state;
    const certificateTemplates = certificateTemplateStore.util.getList('all');
    const isEmpty = (contentModule.title === null || contentModule.title === undefined);
    return (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            { isEmpty ?
              <h2> Loading...</h2>
              :
              <ContentModuleForm
                cancelLink="/admin/authoring/content-modules"
                certificateTemplates={certificateTemplates}
                formHelpers={formHelpers}
                formTitle="Create Content Module"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                sponsorStore={sponsorStore}
                studyStore={studyStore}
                contentModule={contentModule}
              />
            }
          </section>
          <AlertModal
            alertMessage={this.state.alertMessage}
            alertTitle={"Error!"}
            closeAction={this._toggleAlertModal}
            confirmAction={this._toggleAlertModal}
            confirmText={"Try Again"}
            isOpen={this.state.isAlertModalOpen}
            type="danger"
            />
        </div>
      </AuthoringLayout>
    )
  }
}

AdminCreateContentModule.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    certificateTemplateStore: store.certificateTemplate
    , defaultContentModule: store.contentModule.defaultItem
    , sponsorStore: store.sponsor
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateContentModule)
);



// WEBPACK FOOTER //
// modules/contentModule/views/AdminCreateContentModule.js.jsx